module.exports = __webpack_public_path__ + "img/logo-bottom.4819aa8f.png";